module.exports = __webpack_public_path__ + "img/afterlogo.e5657097.png";